export default {
  InspectionBookingDate: 'Inpection Booking Date'
}
